// Operator Inbox — Active tab (DEV-16230). Optional `?signal=<id>`
// search param opens the signal detail drawer in the right pane.
import { createFileRoute } from '@tanstack/react-router';

import { InboxShell } from '../../components/inbox/InboxShell';
import { parseInboxSearch } from '../../components/inbox/inbox-search';

export const Route = createFileRoute('/inbox/')({
  component: ActiveInboxPage,
  validateSearch: parseInboxSearch,
});

function ActiveInboxPage() {
  return <InboxShell tab="active" />;
}
